export default __webpack_public_path__ + "static/media/feedCard.d7582e95.png";